import classes from './SVGIcon.module.scss';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon/Icon';

// eslint-disable-next-line react/display-name
const SVGIcon = forwardRef((props, forwardedRef) => {
  const { name, url, width, height, ...other } = props;

  if (!name && !url) {
    throw new Error("Both icon name and icon url can't be empty");
  }

  if (name) {
    return (
      <Icon
        ref={forwardedRef}
        name={name}
        width={width}
        height={height}
        className={classes.base}
        {...other}
      />
    );
  }
  return (
    <img
      ref={forwardedRef}
      className={classes.base}
      src={url}
      alt=""
      style={{ width, height }}
      {...other}
    />
  );
});

SVGIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.any
};

SVGIcon.displayName = 'SVGIcon';

export default SVGIcon;
